<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Servers"
};
</script>

<style scoped>
</style>
